module.exports = Jsw.skinUrl + "/images/sticker-collection/sticker/arcade-cabinet.png?958723b040fdfe4a98dadc37abc7eb32";